import {
  useIsMobile,
  useModalContext,
  WSCircleIconProps,
  WSPage,
  WSTable,
  WSTableColumn,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WSPersistentUpgradeButton } from "../../../components/Membership/WSPersistentUpgradeButton";
import { useListCollaboratorSettingsAdditionalData } from "../../../query/payments/queries";
import { WSFrontendFeature } from "../../../Settings/utils/subscriptionUtils";
import { WSQueries } from "../../../query/WSQuery";
import { Route, useHistory } from "react-router-dom";
import { InvoicesCollaboratorsCustomFieldsDetails } from "./InvoicesCollaboratorsCustomFieldsDetails";
import {
  ADD_COLLABORATOR_CUSTOM_FIELD_MODAL,
  AddCustomFieldModal
} from "./modals/AddCustomFieldModal";
import {
  IAdditionalData,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";

export const InvoicesCollaboratorsCustomFields: React.FC = () => {
  const { openModal } = useModalContext();
  const history = useHistory();
  const isMobile = useIsMobile();

  const qListAdditionalData = useListCollaboratorSettingsAdditionalData();

  const columns: Array<WSTableColumn<IAdditionalData>> = [
    {
      config: {
        gridTemplateSizeMax: "5fr"
      },
      renderFunction: row => (
        <WSText.Label color="grey700" singleLine>
          {row.data.name}
        </WSText.Label>
      )
    }
  ];

  return (
    <>
      <AddCustomFieldModal />

      <Route
        path={
          "/member/invoices/contacts/collaborators/custom-fields/:additionalDataId"
        }
        component={InvoicesCollaboratorsCustomFieldsDetails}
        exact
      />

      <WSPage
        title="Collaborators Custom Fields"
        primaryButton={
          isMobile
            ? undefined
            : {
                label: "Add collaborator field",
                name: "addCustomField",
                onClick: () => openModal(ADD_COLLABORATOR_CUSTOM_FIELD_MODAL)
              }
        }
      >
        <WSQueries queries={{ qListAdditionalData }}>
          {({ qListAdditionalData }) => {
            const tableData = qListAdditionalData.data.map(dataItem => {
              return {
                icon: {
                  icon:
                    dataItem.type === WSDataTypes.String
                      ? "receipt"
                      : "checkbox"
                } as WSCircleIconProps,
                data: dataItem,
                id: (dataItem as any).id
              };
            });

            return (
              <>
                <WSTable
                  mt="L"
                  showIcon
                  showArrow
                  bottomMessage={
                    tableData.length ? null : (
                      <WSText>
                        No custom fields yet.{" "}
                        <WSPersistentUpgradeButton
                          feature={WSFrontendFeature.InviteAndPayCollaborator}
                          kind="Link"
                          inline
                          onClick={() => {
                            openModal(ADD_COLLABORATOR_CUSTOM_FIELD_MODAL);
                          }}
                        >
                          Add custom field
                        </WSPersistentUpgradeButton>
                      </WSText>
                    )
                  }
                  onRowClick={item => {
                    history.push(
                      `/member/invoices/contacts/collaborators/custom-fields/${item.id}`
                    );
                  }}
                  columns={columns}
                  tableData={tableData}
                />
                {isMobile && tableData.length ? (
                  <WSPersistentUpgradeButton
                    mt="M"
                    feature={WSFrontendFeature.InviteAndPayCollaborator}
                    kind="Primary"
                    fullWidth
                    inline
                    onClick={() => {
                      openModal(ADD_COLLABORATOR_CUSTOM_FIELD_MODAL);
                    }}
                  >
                    Add custom collaborator field
                  </WSPersistentUpgradeButton>
                ) : null}
                <WSText.Paragraph color="grey500" mt="M">
                  Custom collaborator fields enable you to store custom data
                  about your collaborators in Wingspan. These fields can be
                  updated by editing an individual collaborator, or via the
                  collaborator bulk upload.
                </WSText.Paragraph>
                <WSText.Paragraph color="grey500" mt="S">
                  Custom fields are visible on the collaborator profile and on
                  collaborator reports. Your collaborators can not see or edit
                  the custom fields on their profiles.
                </WSText.Paragraph>
              </>
            );
          }}
        </WSQueries>
      </WSPage>
    </>
  );
};
